import Img from 'components/Img';
import React from 'react';
import 'twin.macro';

interface Props {
  imageUrl: string;
  alt?: string;
  className?: string;
}

export default function DemoImage({ imageUrl, className, alt }: Props) {
  return (
    <div className={className} tw="relative overflow-hidden">
      <div tw="mx-auto max-w-7xl px-6 lg:px-8">
        <Img
          s3Path={imageUrl}
          alt={alt}
          tw="shadow-2xl ring-1 mb-[-12%] ring-neutral-intense/10 rounded-lg"
        />
        <div tw="relative">
          <div tw="absolute -inset-x-20 bottom-0 bg-gradient-to-t from-gray-100 pt-[12%]" />
        </div>
      </div>
    </div>
  );
}
